import { createSelector } from '@reduxjs/toolkit';
import { camelCase, orderBy } from 'lodash-es';
import { crewLeadLabel } from '@s20/i18n';
import { selectItemById } from '../common';
import { RootState } from '../../store';

const commonState = (state: RootState) => state.common;

export const getUser = createSelector(commonState, (common) => common.user);
export const getIsAuthenticated = createSelector(commonState, (common) => common.isAuthenticated);
export const getFormIsOpen = createSelector(commonState, (common) => common.formIsOpen);
export const getPageTitle = createSelector(commonState, (common) => common.pageTitle);
export const getVersion = createSelector(commonState, (common) => common.version);
export const getTenant = createSelector(commonState, (common) => common.tenant);
export const getTenantSettings = createSelector(commonState, (common) => common.tenantSettings);
export const getTenantTheme = createSelector(commonState, (common) => common.tenantTheme);
export const getTimesheetNotifications = createSelector(commonState, (common) => common.timesheetNotifications);
export const getAllTenants = createSelector(commonState, (common) => common.allTenants);

export const getTenantId = createSelector(
    getTenant,
    (tenant) => tenant?.id,
);

export const getUserId = createSelector(
    getUser,
    (user) => user?.userId,
);

export const getUserShortcuts = createSelector(
    commonState,
    (common) => {
        const shortcuts = common.user?.shortcuts || [];

        return orderBy(shortcuts, (shortcut) => shortcut.order).filter((shortcut) => shortcut.active);
    },
);

export const getUserIsAdmin = createSelector(
    getUser,
    (user) => user?.roles.some((x) => x.name === 'Administrator'),
);

export const getTenantSetting = createSelector(
    getTenantSettings,
    selectItemById,
    (tenantSettings, settingName) => {
        const name = camelCase(settingName);

        return tenantSettings && tenantSettings[name];
    },
);

export const getPreferredLanguageCode = createSelector(
    getUser,
    (user) => user?.preferredLanguage ?? 'en',
);

export const getCrewLeadLabel = createSelector(
    getTenantSettings,
    (settings) => settings && crewLeadLabel(settings),
);